"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecordType = void 0;
const validator_1 = require("@leavy/validator");
const transformer_1 = require("@leavy/validator/lib/base/transformer");
function isType(ctor, value) {
    return value.constructor === ctor || value instanceof ctor;
}
function isValidRecord(value) {
    return (value != null
        && typeof value === "object"
        && value.constructor === Object);
}
function RecordType(valueTypeProvider, options) {
    return (target, propertyKey) => {
        const valueType = valueTypeProvider();
        const transformBefore = options === null || options === void 0 ? void 0 : options.transformBefore;
        const includeKey = options === null || options === void 0 ? void 0 : options.includeKey;
        (0, validator_1.Transform)((maybeRecord) => {
            if (maybeRecord === null)
                return null;
            if (!isValidRecord(maybeRecord))
                return undefined;
            const recordEntries = Object.entries(maybeRecord);
            for (const [recordKey, rawRecordValue] of recordEntries) {
                if (includeKey) {
                    const shouldInclude = includeKey(recordKey);
                    if (!shouldInclude) {
                        delete maybeRecord[recordKey];
                        continue;
                    }
                }
                const recordValue = transformBefore ?
                    transformBefore(rawRecordValue) : rawRecordValue;
                if (recordValue != rawRecordValue) {
                    maybeRecord[recordKey] = recordValue;
                }
                if (isType(valueType, recordValue))
                    continue;
                maybeRecord[recordKey] = (0, transformer_1.plainToClass)(valueType, recordValue);
            }
            return maybeRecord;
        }, { toClassOnly: true })(target, propertyKey);
    };
}
exports.RecordType = RecordType;
//# sourceMappingURL=RecordType.js.map